// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholderContainer_d30207b1{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;padding:60px 20px;text-align:center;color:#666}.placeholderIcon_f2977f6a{font-size:48px}.placeholderText_b8648d59{font-size:14px;color:#999}`, ""]);
// Exports
export var placeholderContainer = `placeholderContainer_d30207b1`;
export var placeholderIcon = `placeholderIcon_f2977f6a`;
export var placeholderText = `placeholderText_b8648d59`;
export default ___CSS_LOADER_EXPORT___;
